<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">新建/编辑会议</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">

          <create-meeting ref="create" :userData="userData" :formByFather="form" :formByFather2="form2"
            :isForm2ByFather="isForm2" :selectArrByFather="selectArrByUsers" :selectPlanArrByFather="selectPlanArr">
          </create-meeting>

          <!-- <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批人">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item> -->

            <!-- 审批 -->
            <!-- <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div> -->

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createMeeting()" class="form-btn" type="success">确认提交会议申请
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Attachments from '@/components/Attachments'
  import approvalUsers from '@/Mixins/approvalUsers'

  import ApprovalItem from '@/components/ApprovalItem'
  import CreateMeeting from './createForm'
  export default {
    components: {
      ApprovalItem,
      CreateMeeting,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        project: {},
        tableData: [],

        project: {},
        // 参会人员
        selectArrByUsers: [],
        // 会议准备人员
        selectPlanArr: [],
        form: {
          "approvalType": "",
          "approvalUserIds": "",
          "attachments": [],
          "conferenceTime": "",
          "depId": 0,
          "name": "",
          "req": "",
          "roomId": 0,
          "useTime": "",
          "userIds": "",
          "json": true,
          isWx: true,
          isSms: false
        },
        isForm2: false,
        form2: {
          conferenceApplyId: "",
          isHaveCamera: false,
          isHaveEat: false,
          isHaveProjector: false,
          isHaveSeat: false,
          isHaveTea: false,
          seat: "",
          remark: "",
          userId: "",
        },
        approvalUsersData: [],

        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",
        formLoading: false,

        applyInfo: '',
      }
    },
    created() {
      let depId = this.$route.query.depId
      this.form.depId = depId ? depId / 1 : this.userData.secDepIds.split(",")[0] / 1

      let roomId = this.$route.query.roomId / 1
      this.form.roomId = roomId ? roomId : ''

      console.log(depId, roomId)

      this.getApplyData()
      // this.approvalUsersData = this.approvalUsers['c130']
    },
    mounted() {},
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.form.applyId = this.$route.query.applyId
        console.log(this.form.applyId)

        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          // this.setSelectArr(this.applyInfo, 130)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/conference/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo
          // 会议信息
          this.form.name = this.applyInfo.name
          this.form.req = this.applyInfo.req
          this.form.conferenceTime = this.applyInfo.conferenceTime
          this.form.useTime = this.applyInfo.useTime
          this.selectArrByUsers = this.applyInfo.users
          this.form.isWx = this.applyInfo.isWx
          this.form.isSms = this.applyInfo.isSms
          // 会议准备
          // conferenceApplyId: "",
          // isHaveCamera: false,
          // isHaveEat: false,
          // isHaveProjector: false,
          // isHaveSeat: false,
          // isHaveTea: false,
          // seat: "",
          // remark: "",
          // userId: "",
          if (this.applyInfo.conferencePlan) {
            this.isForm2 = true
            this.form2 = this.applyInfo.conferencePlan
            this.selectPlanArr = []
            this.selectPlanArr.push(this.applyInfo.conferencePlan.receiver)
          }

          this.form.attachments = this.applyInfo.attachments ? this.applyInfo.attachments : []


          // this.setSelectArr(this.applyInfo, 130)
          this.formLoading = false
        })
      },

      // 会议准备
      meetingPlan(id, cb) {
        if (this.$refs.create.getIsFrom2()) {
          this.form2 = this.$refs.create.getFrom2Data()
          this.form2.conferenceApplyId = id
          let _selectPlanArr = this.$refs.create.getSelectPlanArr()
          this.form2.userId = _selectPlanArr[0].id
          ajax.post('/conference/plan/add', this.form2, (res) => {
            cb && cb()
          })
        } else {
          cb && cb()
        }
      },
      // 创建会议
      createMeeting() {
        this.form = this.$refs.create.getFromData()

        if (!this.form.depId || !this.form.name || !this.form.roomId || !this.form.conferenceTime || !this.form
          .userIds) {
          this.$message.error('新建会议带*项目均是必填项')
          return
        }

        this.form.approvalType = this.approvalType
        // this.form.approvalUserIds = this.$refs.approval.getUserIds()

        this.formLoading = true
        let _url = !this.form.applyId ? '/conference/apply/add' : '/conference/apply/edit?applyId=' + this.form.applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false

          // 会议准备
          this.meetingPlan(res.vo.id, () => {
            this.$message.success("提交会议申请成功")
            this.$router.back()
          })
        }, () => {
          this.formLoading = false
        })
      },
    },
    watch: {
      // 'form.type'() {
      //   this.approvalUsersData = this.approvalUsers['c10_' + this.form.type]
      // },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/meeting/createApproval.vue